import { render, staticRenderFns } from "./addMultiAppeal.vue?vue&type=template&id=3b592788&scoped=true&"
import script from "./addMultiAppeal.vue?vue&type=script&lang=ts&"
export * from "./addMultiAppeal.vue?vue&type=script&lang=ts&"
import style0 from "./addMultiAppeal.vue?vue&type=style&index=0&id=3b592788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b592788",
  null
  
)

export default component.exports